// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"f6d2af04","240":"ec3d5eda","241":"47b23d05","300":"ddaaab79","395":"62f0f880","570":"b93a18e1","617":"2fc698fc","649":"a96a31d6","754":"a1c3a53b","960":"2c483874"}[chunkId] + ".chunk.js";
};